import { AltroImportoLiquidato } from 'src/app/common/models/altro-importo-liquidato';
import { CostoGestioneLiquidato } from 'src/app/common/models/costo-gestione-liquidato';
import { ImportoLiquidato } from 'src/app/common/models/importo-liquidato';
import { Liquidato } from 'src/app/common/models/liquidato';
import { TipoLiquidato } from 'src/app/common/models/tipologiche/tipo-liquidato';

export class SezioneEsitiLiquidatiAdapter {
  liquidato: Liquidato = new Liquidato();

  constructor(liquidato: Liquidato) {
    this.liquidato.id = liquidato.id ? liquidato.id : null;
    this.liquidato.dataLiquidato = liquidato.dataLiquidato ? liquidato.dataLiquidato : new Date().getTime();
    this.liquidato.tipoLiquidato = liquidato.tipoLiquidato ? liquidato.tipoLiquidato : new TipoLiquidato();
    this.liquidato.note = liquidato.note;
    this.liquidato.controparte = liquidato.controparte ? liquidato.controparte : null;
    this.liquidato.altraParte = liquidato.altraParte ? liquidato.altraParte : null;
    this.liquidato.legaleIncaricato = liquidato.legaleIncaricato ? liquidato.legaleIncaricato : null;
    this.liquidato.ripartizioneEqua = liquidato.ripartizioneEqua ? liquidato.ripartizioneEqua : false;
    this.liquidato.daEliminare = liquidato.daEliminare ? liquidato.daEliminare : false;
    // this.liquidato.sorte = liquidato.sorte;
    // this.liquidato.rivalutazione = liquidato.rivalutazione;
    // this.liquidato.speseLite = liquidato.speseLite;
    this.liquidato.societa = liquidato.societa;
    this.liquidato.importoLiquidato = liquidato.importoLiquidato ? liquidato.importoLiquidato : new ImportoLiquidato();
    if(liquidato.importoLiquidato){
      this.liquidato.importoLiquidato.importo = liquidato.importoLiquidato.importo;
      this.liquidato.importoLiquidato.interessi = liquidato.importoLiquidato.interessi;
      this.liquidato.importoLiquidato.sanzioni = liquidato.importoLiquidato.sanzioni;
    }
    this.liquidato.costoGestioneLiquidato = liquidato.costoGestioneLiquidato ? liquidato.costoGestioneLiquidato : new CostoGestioneLiquidato();
    if(liquidato.costoGestioneLiquidato){
      this.liquidato.costoGestioneLiquidato.diritti = liquidato.costoGestioneLiquidato.diritti;
      this.liquidato.costoGestioneLiquidato.flagRitenutaAcconto = liquidato.costoGestioneLiquidato.flagRitenutaAcconto ? liquidato.costoGestioneLiquidato.flagRitenutaAcconto : false;
      this.liquidato.costoGestioneLiquidato.speseLiquidate = liquidato.costoGestioneLiquidato.speseLiquidate;
      this.liquidato.costoGestioneLiquidato.irap = liquidato.costoGestioneLiquidato.irap;
      this.liquidato.costoGestioneLiquidato.oneriRiflessi = liquidato.costoGestioneLiquidato.oneriRiflessi;
      this.liquidato.costoGestioneLiquidato.speseMarcheNotifica = liquidato.costoGestioneLiquidato.speseMarcheNotifica;
      this.liquidato.costoGestioneLiquidato.art96CPC = liquidato.costoGestioneLiquidato.art96CPC;
      this.liquidato.costoGestioneLiquidato.f23 = liquidato.costoGestioneLiquidato.f23;
      this.liquidato.costoGestioneLiquidato.risarcimento = liquidato.costoGestioneLiquidato.risarcimento;
    }
    else{
      this.liquidato.costoGestioneLiquidato.flagRitenutaAcconto = false;
      this.liquidato.costoGestioneLiquidato.irap = 8.50;
      this.liquidato.costoGestioneLiquidato.oneriRiflessi = 23.08;
    }
    this.liquidato.altroImportoLiquidato = liquidato.altroImportoLiquidato ? liquidato.altroImportoLiquidato : new AltroImportoLiquidato();
    if(liquidato.altroImportoLiquidato){
      this.liquidato.altroImportoLiquidato.speseRegistrazione = liquidato.altroImportoLiquidato.speseRegistrazione;
      this.liquidato.altroImportoLiquidato.contributoUnificato = liquidato.altroImportoLiquidato.contributoUnificato;
      this.liquidato.altroImportoLiquidato.altroImporto = liquidato.altroImportoLiquidato.altroImporto;
    }

  }
}
